<template>
  <section class="container categoreis-home">
   
    <div
      v-if="categories && categories.length"
      id="categoreis-slider"
      class="categoreis-slider position-relative"
    >
      <div class="swiper-container ">
        <div class="swiper-wrapper">
          <div
            v-for="categorie in categories"
            :key="categorie.id"
            class="swiper-slide "
          >
            <CardCategore :data="categorie" />
          </div>
        </div>
      </div>
      <div class=" swiper-button-next text-center">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="15"
          height="18"
          fill="currentColor"
          class="bi bi-chevron-compact-right"
          viewBox="0 0 16 16"
        >
          <path
            fill-rule="evenodd"
            d="M6.776 1.553a.5.5 0 0 1 .671.223l3 6a.5.5 0 0 1 0 .448l-3 6a.5.5 0 1 1-.894-.448L9.44 8 6.553 2.224a.5.5 0 0 1 .223-.671z"
            fill="#999"
          />
        </svg>
      </div>
      <div class=" swiper-button-prev">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="15"
          height="18"
          fill="currentColor"
          class="bi bi-chevron-compact-left"
          viewBox="0 0 16 16"
        >
          <path
            fill-rule="evenodd"
            d="M9.224 1.553a.5.5 0 0 1 .223.67L6.56 8l2.888 5.776a.5.5 0 1 1-.894.448l-3-6a.5.5 0 0 1 0-.448l3-6a.5.5 0 0 1 .67-.223z"
            fill="#999"
          />
        </svg>
      </div>
    </div>
  </section>
</template>

<script>
import Swiper from "swiper/swiper-bundle.min.js";
import CardCategore from "@/parts/Front/components/HomeCategoreis/card.vue";
import { BSkeletonImg } from "bootstrap-vue";

export default {
  name: "HomeCategoreis",
  components: {
    CardCategore,
    BSkeletonImg,
  },

  inject: ["mediaQueries"],

  methods: {
    initCategoreis(kill = false) {
      this.initSwiper("categoreis-home", kill, () => {
        new Swiper("#categoreis-slider .swiper-container", {
          spaceBetween: 30,
          loop: false,
          speed: 500,

          navigation: {
            nextEl: "#categoreis-slider .swiper-button-next",
            prevEl: "#categoreis-slider .swiper-button-prev",
          },
          breakpoints: {
            250: {
              slidesPerView: 2.5,
              spaceBetween: 15,
            },
            500: {
              slidesPerView: 2.5,
              spaceBetween: 15,
            },
            768: {
              slidesPerView: 3,
              spaceBetween: 20,
            },
            992: {
              slidesPerView: 4,
              spaceBetween: 20,
            },
            1230: {
              slidesPerView: 5,
              spaceBetween: 20,
            },
            1500: {
              slidesPerView: 6,
              spaceBetween: 20,
            },
          },
        });
      });
    },
  },
  mounted() {
    this.initCategoreis();
  },
  watch: {
    categories() {
      this.initCategoreis();
    },
  },
  computed: {
    categories() {
      if (!this.$store.getters["front/getHomeData"]) return [];
      return this.$store.getters["front/getHomeData"].special_categories;
    },
    freeShipping() {
      console.log(this.$store.getters["front/getHomeData"],"11111111111111111111111");
      if (!this.$store.getters["front/getHomeData"]) return [];
      return this.$store.getters["front/getHomeData"].free_shipping_products;
    },

  },
};
</script>

<style scoped>
.categoreis-home {
  margin-top: 70px;
  background-color: #3535350d;
  border-radius: 16px;
}
.swiper-button-prev,
.swiper-button-next {
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  position: absolute;
  border: 1px solid #e9e9e9;
  transition: all 0.3s;
}
.swiper-button-next {
  right: -20px;
}
.swiper-button-prev {
  left: -20px;
}
.categoreis-home .swiper-button-prev:hover,
.categoreis-home .swiper-button-next:hover {
  background-color: #000;
}
.categoreis-home .swiper-button-prev .bi path {
  stroke-width: 3px;
}
.categoreis-home .swiper-button-prev:hover .bi path,
.categoreis-home .swiper-button-next:hover .bi path {
  fill: #fff;
}
@media screen and (max-width: 639px) {
  .swiper-button-prev,
  .swiper-button-next {
    display: none;
  }
}
</style>
<style>
.categoreis-home .swiper-wrapper  {
  padding-top: 1rem ;
 
}
.categoreis-home .swiper-button-prev:after,
.categoreis-home .swiper-container-rtl .swiper-button-next:after,
.categoreis-home .swiper-button-next:after,
.categoreis-home .swiper-container-rtl .swiper-button-prev:after {
  display: none;
}
@media screen and (max-width: 639px) {
}
</style>
